<template>
    <CommonModal ref="commonModal" :size="size" :onHideOnlyX="true">
        <template v-slot:CommonModalTitle>
            <div>{{ $t('vinov_kvkk') }}</div>
        </template>
        <template v-slot:CommonModalContent>
            <div v-if="loading" class="text-center py-5">
                <b-spinner label="Loading..." variant="primary"></b-spinner>
            </div>
            <div v-else-if="content" class="contract-modal-content" v-html="content"></div>
        </template>
    </CommonModal>
</template>

<script>
import CommonModal from "@/components/elements/CommonModal";
import ConstantService from "@/services/ConstantService";
import qs from "qs";

export default {
    name: "VinovKvkkModal",
    components: {
        CommonModal
    },
    props: {
        size: {
            type: String,
            default: "lg"
        }
    },
    data() {
        return {
            loading: false,
            content: ""
        };
    },
    watch: {
        "$i18n.locale": {
            handler() {
                this.fetchContent();
            }
        }
    },
    methods: {
        show() {
            if (this.$refs.commonModal && this.$refs.commonModal.$refs.commonModal) {
                this.$refs.commonModal.$refs.commonModal.show();
            }
            this.fetchContent();
        },
        hide() {
            if (this.$refs.commonModal && this.$refs.commonModal.$refs.commonModal) {
                this.$refs.commonModal.$refs.commonModal.hide();
            }
        },
        decodeHtml(html) {
            if (!html) return "";
            let txt = document.createElement("textarea");
            txt.innerHTML = html;
            let decoded = txt.value;
            if (decoded.includes("&lt;")) {
                txt.innerHTML = decoded;
                decoded = txt.value;
            }
            return decoded;
        },
        fetchContent() {
            this.loading = true;
            const lang = this.$i18n.locale;
            const key = lang === "en" ? "epayment.vinovkvkk_en" : "epayment.vinovkvkk";
            const config = {
                params: { key },
                paramsSerializer: (params) => qs.stringify(params, { encode: false })
            };

            ConstantService.getValue(config)
                .then(response => {
                    if (response.data && response.data.data) {
                        this.content = this.decodeHtml(response.data.data);
                    }
                })
                .catch(error => {
                    console.error("Error fetching Vinov KVKK constant:", error);
                })
                .finally(() => {
                    this.loading = false;
                });
        }
    }
};
</script>

<style scoped>
.contract-modal-content {
    white-space: normal !important;
    word-break: break-word;
    overflow-wrap: break-word;
    max-width: 100%;
    line-height: 1.6;
}
.contract-modal-content ::v-deep p,
.contract-modal-content ::v-deep h1,
.contract-modal-content ::v-deep h2,
.contract-modal-content ::v-deep h3,
.contract-modal-content ::v-deep h4,
.contract-modal-content ::v-deep h5,
.contract-modal-content ::v-deep h6,
.contract-modal-content ::v-deep div,
.contract-modal-content ::v-deep span,
.contract-modal-content ::v-deep li {
    white-space: normal !important;
    word-break: break-word;
    overflow-wrap: break-word;
}
.contract-modal-content ::v-deep p {
    margin-bottom: 0.8rem;
}
</style>
